import { render, staticRenderFns } from "./ContractPreviewPayment.vue?vue&type=template&id=37225c22&scoped=true"
import script from "./ContractPreviewPayment.vue?vue&type=script&lang=js"
export * from "./ContractPreviewPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37225c22",
  null
  
)

export default component.exports